module.exports = __webpack_public_path__ + "static/media/1.14dcc8e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ourStaff/1.jpg
// module id = 1415
// module chunks = 0